import { Component, OnInit } from '@angular/core';
import { ResultConfigViewModel } from 'src/app/models/results/result-config-view-model';
import { DataService } from 'src/app/services/data/data.service';
import { AngularFireAuth } from '@angular/fire/auth';
import firebase from 'firebase/app';
import 'firebase/auth';
import { map, switchMap, take } from 'rxjs/operators';
import { environment } from 'src/environments/non-vendor/environment';
import { ResultsService } from 'src/app/services/results/results.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-results-config',
  templateUrl: './results-config.component.html',
  styleUrls: ['./results-config.component.scss']
})
export class ResultsConfigComponent implements OnInit {
  localeName = "";
  user: firebase.User | null = null;
  adminEmails: string[] = [];
  items: ResultConfigViewModel[] = [];
  displayedColumns: string[] = ['select', 'productDescShort', 'materialID'];
  successStatus = "Saved";
  errorStatus = "Error";

  constructor(private resultsService: ResultsService, private dataService: DataService, private utilityService: UtilityService, public auth: AngularFireAuth) { }

  ngOnInit(): void {
    this.localeName = this.utilityService.getLocaleInfo().localeName;
    this.getItemsForAuthorizedUser();
  }
  
  async getItemsForAuthorizedUser(): Promise<void> {
    this.auth.user.pipe(
      take(1),
      switchMap(async authUser => {
        this.user = authUser;

        if (!authUser) {
          // firestore only allows authenticated users, so sign in with default creds to allow the email addresses to be retrieved.
          await this.auth.signInWithEmailAndPassword(environment.firebaseUserEmail, environment.firebase.apiKey);
        }
      }),
      switchMap(() => this.dataService.getAdminEmailAddresses()),
      map(emails => {
        this.adminEmails = emails
      })
    ).subscribe(() => {
      if (this.userIsAdmin(this.user)) {
        this.getItems();
      } else {
        this.login();
      }
    });
  }

  async login(): Promise<void> {
    
    await this.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider())
      .then((userCred: any) => {
        if (this.userIsAdmin(userCred.user)) {
          this.getItems();
        } else {
          alert("Your Google account doesn't have access to this page.");
        }
      })
      .catch(err => {
        console.log(err);
        alert("An error occurred. Please try refreshing the page.");
      });
  }

  userIsAdmin(user: firebase.User | null): boolean {
    return !!user && this.adminEmails.some(email => email.toUpperCase() === user?.email?.toUpperCase());
  }

  getItems(): void {
    this.resultsService.getItemsForResultConfig().subscribe(dbItems => {
      dbItems.sort((a, b) => (a.productDescShort > b.productDescShort) ? 1 : -1);
      this.items = dbItems;
    });
  }

  async updateShowInResultsSetting(item: ResultConfigViewModel): Promise<void> {
    // need to check for !== false because the showInResults field doesn't yet exist on some items,
    // and this condition will grab any items that either don't have the field or do have it and it's set to true
    item.showInResults = item.showInResults !== false ? false : true;

    await this.dataService.updateResultConfigItem(item)
      .then(() => item.showInResultsUpdateStatus = this.successStatus)
      .catch(err => {
        console.log(err);
        item.showInResultsUpdateStatus = this.errorStatus;
      });
  }

  checkboxLabel(row: ResultConfigViewModel): string {
    return `${row.showInResults !== false ? 'deselect' : 'select'} ${row.materialID}`;
  }
}
